<template>
  <SACModal
    modalClass="partner-settings-action-modal"
    :cardClass="`psettings-${actionView}`"
    :show="showAction"
    :close="() => toggleModal(false)"
  >
    <template
      v-if="actionView === 'warning-save'"
      #content
    >
      <UnsavedChangesWarning />
    </template>
    <template
      v-else-if="actionView === 'service-changes-warning'"
      #content
    >
      <SettingChangesWarning />
    </template>
    <template
      v-else-if="actionView === 'role-info'"
      #content
    >
      <RoleInfoPopup />
    </template>
  </SACModal>
</template>
<script>
import partnerSettingsMixin from '../../mixins/partnerSettingsMixin';
import SACModal from '../sac/SACModal.vue';
import UnsavedChangesWarning from './UnsavedChangesWarning.vue';
import SettingChangesWarning from './SettingChangesWarning.vue';
import RoleInfoPopup from './RoleInfoPopup.vue';

export default {
  name: 'ActionModal',
  components: {
    SACModal,
    UnsavedChangesWarning,
    SettingChangesWarning,
    RoleInfoPopup,
  },
  mixins: [partnerSettingsMixin],
};
</script>
<style lang="scss">
@import '../../assets/styles/variables.scss';
.partner-settings-action-modal {
  .psettings-warning-save, .psettings-service-changes-warning {
    width: 500px;
    height: 250px;
  }
  .psettings-role-info {
    width: 700px;
    height: 400px;
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;
    .ac-header-container {
      padding: 29px 24px 19px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $NBLUE10;
      .ac-header {
        font-size: 1.25rem;
        font-weight: 500;
      }
      .ac-close-button {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background-color: $NBLUE10;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background-color: $NBLUE20;
        }
        .ac-close {
          width: 10px;
          height: 10px;
        }
      }
    }
    .ac-body-container {
      flex: 1;
      padding: 20px;
      display: flex;
      flex-direction: column;
    }
    .ac-error {
      color: $TOMATO100 !important;
      font-size: 0.875rem;
      font-weight: 500;
      padding-left: 4px;
      margin-top: 5px;
    }
  }
  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid $NBLUE10;
    button:not(:last-child) {
      margin-right: 12px;
    }
    .ac-form-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE100;
      color: $WHITE;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE90;
      }
      &:disabled {
        background-color: $N50
      };
      &:not(:last-child) {
        background-color: $N100;
        color: $WHITE;
        &:hover {
          background-color: $NBLUE20;
        }
      }
    }
    .ac-form-cancel-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $TOMATO100;
      color: $WHITE;
      font-weight: 600;
      &:hover {
        background-color: $TOMATO200;
      }
    }
  }
}
</style>
